import FilterSkiDistance from './FilterSkiDistance';

export default FilterSkiDistance;
